import type { Color } from "../types";

/**
 * Interface of entity which has average color.
 */
export interface HasAverageColor {
  /**
   * Returns average color.
   */
  getAverageColor(): Color;
}

/**
 * Checks if given argument is HasAverageColor.
 *
 * @param obj
 */
export function isHasAverageColor(obj: unknown): obj is HasAverageColor {
  return (
    typeof obj === "object" &&
    obj !== null &&
    typeof (obj as Partial<HasAverageColor>).getAverageColor === "function"
  );
}
